type Step = {
  title: string;
  detail: string;
};

type StepsProps = {
  steps: readonly Step[];
};

export const consultationSteps: readonly Step[] = [
  {
    title: "Send the details",
    detail: "Describe the tank, what changed, and any water readings you have. It takes a few minutes.",
  },
  {
    title: "Meet by video",
    detail: "Point the camera at the tank, the filter, and the test kit. A trained eye sees what a forum thread cannot.",
  },
  {
    title: "Leave with a plan",
    detail: "One prioritized next step, and a clear list of what to skip. Advice first, no equipment upsell.",
  },
];

export function Steps({ steps }: StepsProps) {
  return (
    <ol className="steps">
      {steps.map((step, index) => (
        <li className="steps__item" key={step.title}>
          <span className="steps__number">{String(index + 1).padStart(2, "0")}</span>
          <h3 className="steps__title">{step.title}</h3>
          <p className="steps__detail">{step.detail}</p>
        </li>
      ))}
    </ol>
  );
}
